import React from 'react'
import { BASE_URL } from '../../constants';

const loaderStyle = {
    'position': 'fixed',
    'background': 'rgb(62 62 62 / 30%)',
    'width': '100%',
    'height': '100vh',
    'zIndex': '99999',
    'top': '0',
    'bottom': '0',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',  
};

const Loader = () => {
  return (
    <div style={loaderStyle}>
        <img src={`${BASE_URL}/assets/images/loader-v1.gif`} />
    </div>
  )
}

export default Loader